import * as React from 'react';

const UsersIcon = ({ fill = null, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    aria-labelledby="title"
    className={className}
  >
    <title>Users</title>
    <g fill={fill}>
      <path d="M430.769 312.653l-48.658-13.902C427.833 251.806 432 197.605 432 176 432 78.845 353.262 0 256 0 158.859 0 80 78.724 80 176c0 21.609 4.167 75.806 49.889 122.751l-48.658 13.902C19.49 330.294 0 386.442 0 420.344V448c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64v-27.656c0-33.198-18.981-89.905-81.231-107.691zM256 32c79.529 0 144 64.471 144 144s-64.471 144-144 144-144-64.471-144-144S176.471 32 256 32zm224 416c0 17.673-14.327 32-32 32H64c-17.673 0-32-14.327-32-32v-27.656c0-35.718 23.678-67.109 58.022-76.922l69.862-19.961C176.969 334.613 210.109 352 256 352c45.897 0 79.038-17.392 96.116-28.538l69.862 19.961C456.322 353.235 480 384.626 480 420.344V448z" />
    </g>
  </svg>
);

export default UsersIcon;
